import translate from '@translate';
import { ConstantsCodeType, ConstantsCodesObjectType } from 'src/types/constantsCodes';

/** Typy příloh produktu (instruction / label / other) — stejné jako ve FileUpload selectu. */
export function getProductAttachmentFileTypeSelectOptions(): ConstantsCodeType[] {
    return [
        { value: 'instruction', label: translate('file.type.instruction') },
        { value: 'label', label: translate('file.type.label') },
        { value: 'other', label: translate('file.type.other') },
    ];
}

export function getProductAttachmentFileTypeCodesObject(): ConstantsCodesObjectType {
    return getProductAttachmentFileTypeSelectOptions().reduce<ConstantsCodesObjectType>((acc, item) => {
        acc[String(item.value)] = item;
        return acc;
    }, {});
}
